import { PrintMap } from "esdm-map/dist/map/tools/PrintMap";
import { IPrintOptions } from "esdm-map/dist/map/tools/IPrintOptions";
import { DownloadMapPng } from "esdm-map/dist/map/tools/DownloadMapPng";
import { IMapViewStore } from "esdm-map/dist/map/store/IMapViewStore";
import { IVectorLayerGroupFactory } from "esdm-map/dist/layers/groups/vector/interfaces/IVectorLayerGroupFactory";
import { IMapContextMenu } from "esdm-map/dist/map/tools/IMapContextMenu";
import { IFeatureLoader } from "esdm-map/dist/layers/vector/sources/loaders/interfaces/IFeatureLoader";
import { OgcMapFilter } from "esdm-map/dist/map/filters/OgcMapFilter";
import { VectorLayerGroupFactory } from "esdm-map/dist/layers/groups/vector/VectorLayerGroupFactory";
import { MapViewStore } from "esdm-map/dist/map/store/MapViewStore";
import { MapContextMenu } from "esdm-map/dist/map/tools/MapContextMenu";
import { ToolTipProvider } from "esdm-map/dist/map/tooltip/ToolTipProvider";
import { IVectorLayerGroupConfig } from "esdm-map/dist/layers/groups/vector/interfaces/IVectorLayerGroupConfig";
import { GeoJsonFeatureLoader } from "esdm-map/dist/layers/vector/sources/loaders/GeoJsonFeatureLoader";
import { ILoaderExtentsBehaviour } from "esdm-map/dist/layers/vector/sources/loaders/behaviours/ILoaderExtentsBehaviour";
import { BoundsLoaderExtentsBehaviour } from "esdm-map/dist/layers/vector/sources/loaders/behaviours/BoundsLoaderBehaviour";
import { IFeatureAdd } from "esdm-map/dist/layers/vector/sources/loaders/interfaces/IFeatureAdd";
import { FeatureAdd } from "esdm-map/dist/layers/vector/sources/loaders/FeatureAdd";
import { ExtentsNavigation } from "esdm-map/dist/map/controls/ExtentsNavigation";
import { LayerGroupFactory } from "esdm-map/dist/layers/groups/LayerGroupFactory";
import { LayerGroupCollection } from "esdm-map/dist/layers/groups/LayerGroupCollection";
import { MapFilters } from "esdm-map/dist/map/filters/MapFilters";
import { GridRef } from "esdm-map/dist/map/controls/GridRef";

import { IMappingTextPack } from "esdm-map/dist/resources/MappingTextPack";
import { MousePosition } from "esdm-map/dist/map/controls/MousePosition";
import { GeoNames } from "esdm-map/dist/gazetteer/geonames";
import { IStyleFactory } from "esdm-map/dist/layers/vector/styles/IStyleFactory";
import { IVectorLayerSourceFactory } from "esdm-map/dist/layers/vector/sources/interfaces";
import { VectorLayerSourceFactory } from "esdm-map/dist/layers/vector/sources";
import { IBaseLayerFactory } from "esdm-map/dist/baselayers/interfaces/IBaseLayerFactory";
import { IVectorLayerGroup } from "esdm-map/dist/layers/groups/vector/interfaces/IVectorLayerGroup";
import { ZoomToDataBounds } from "esdm-map/dist/layers/vector/ZoomToDataBounds";
import { VectorLayerStrategy } from "esdm-map/dist/layers/vector/VectorLayerStrategy";
import { CustomMapLayerSwitcherOverlays } from "./CustomMapLayerSwitcherOverlays";
import {
    MapOptions,
    IMap,
    MapLayerSwitcher,
    IMapAreaMask,
    ILogger,
    IResourceFactory,
    IMapFactory,
    BaseLayerFactory_3857,
    MapFactory,
    Logger,
    MiniMapsForLists,
    BaseLayerType,
    MapFeatureInfo
} from "esdm-map";

import { HbsmrStyleFactory } from "./HbsmrStyleFactory";
import { HbsmrResourcefactory } from "./HbsmrResourceFactory";
import { KentRecordType, KentRecordSubType } from "./KentRecordTypes";
import { DefaultLayerConfigurationFactory } from "./DefaultLayerConfigurationFactory";
import { KentHerBoundary } from "./KentHerBoundary";
import { TextPackLoader, TextPacks } from "./TextPackLoader";
import { DefaultMapOptions } from "./DefaultMapOptions";
import { FeatureAddSmallGeomsAsPoint } from "esdm-map/dist/layers/vector/sources/loaders";
import { HbsmrUser, HbsmrIdentity } from "./HbsmrUser";
import { MapBase } from "./MapBase";
import { LayerGroupCollections } from "esdm-map/dist/layers/groups/LayerGroupCollections";
import { IlayerGroupCollectionConfig } from "esdm-map/dist/layers/groups/IlayerGroupCollectionConfig";
import { KentBaseLayerTypes, KentBaseMapping_27700 } from "./KentBaseMapping_27700";
import { MapToolTip, ToolTipOptions } from "esdm-map/dist/map/tooltip";
import { debounce } from "debounce";

$(function () {

    function resizeMap() {
        var height = $(window).height() - $("#mapContainer").offset().top;
        if (height <= 500) {
            height = 500;
        }
        $('#mapContainer').height(height);
    };

    let didLoadMap = false;

    let ele = $("#theMap");
    let maxFeatureCount: number = <number>ele.data("max-feature-count");

    let data = $("#searchMapData");
    let searchString: string = <string>data.data("search-string");
    let searchMode: string = <string>data.data("search-mode");
    let recordType: string = <string>data.data("record-type");

    let printOptions: PrintMap = new PrintMap();


    let loadMap = function () {
        HbsmrIdentity.fetch().then(function (e) {
            let user = e;
            let init = function (textpacks: TextPacks) {                        
                let map = new RecordSearchMap("theMap", searchString, searchMode, recordType, maxFeatureCount, printOptions, textpacks.mapping, user);
                didLoadMap = true;
            }
            TextPackLoader.load().then(init);
        });
    }

    if (!printOptions.isPrintMap) {
        window.addEventListener('resize', debounce(resizeMap, 250));  
    } 
    if (printOptions.isPrintMap) {
        loadMap();
    }
    else {
        let bingAPIKey: string = ele.data("bing-api-key");
        let esdmOsmApiKey: string = ele.data("esdm-osm-api-key");
        let baseLayerFactory: IBaseLayerFactory = new KentBaseMapping_27700();        
        let miniMaps = new MiniMapsForLists(KentBaseLayerTypes.KentOS, bingAPIKey, esdmOsmApiKey, baseLayerFactory, "EPSG:27700", "EPSG:27700");

        //disable map tab for sources
        if (recordType === "source") {
            $("#tab2 > a").removeAttr("data-bs-toggle");
            $("#tab2 > a").addClass("disabled");
        }

        //only show the map when the map tab is visible
        $('a[data-bs-toggle="tab"]').on('shown.bs.tab', function (e) {
            let target = $(e.target).attr("href") // activated tab
            if (target === "#tabMap") {
                if (didLoadMap === false) {
                    resizeMap();
                    loadMap();   
                }
            } else if (target === "#tabList" && didLoadMap === true) {
                // If the map has loaded it means the user has visited the 'Map' tab, they could have possibly also put the map into fullscreen mode
                // if they have then we need to redraw/refresh the miniMaps on the search results list, as they don't refresh correctly after exiting
                // the fullscreen mode
                miniMaps.refreshMiniMaps();
            }
        });
    }
});

export class RecordSearchMap extends MapBase {

    private map: IMap;
    private mfOptions: MapOptions;
    private mapStore: IMapViewStore;
    private styleFactory: IStyleFactory;
    private ls: MapLayerSwitcher;
    private vectorLayerGroups: Array<IVectorLayerGroup>;
    private infoPopup: MapFeatureInfo;
    private initialised = false;
    private herMask: IMapAreaMask;
    private geoNames: GeoNames;
    private logger: ILogger;
    private vectorLayerSourceFactory: IVectorLayerSourceFactory;
    private baseLayerFactory: IBaseLayerFactory;
    private mapFactory: IMapFactory;
    private vectorLayerGroupFactory: IVectorLayerGroupFactory;
    private boundsLoaderBehaviour: ILoaderExtentsBehaviour;
    private mapContextMenu: IMapContextMenu;
    private resourcefactory: IResourceFactory;
    private downloadPng: DownloadMapPng;
    private extentsNavigation: ExtentsNavigation;
    private gridRefFinder: GridRef;
    private mousePosition: MousePosition;
    private featureLoader: IFeatureLoader;
    private featureAdd: IFeatureAdd;
    private mapFilter: MapFilters;
    private layerConfigFactory: DefaultLayerConfigurationFactory;
    private layerGroups: LayerGroupCollections;
    private layerGroupFactory: LayerGroupFactory;
    private mapToolTip: MapToolTip;

    constructor(
        private _mapElementId: string,      
        private _searchString: string,
        private _searchMode: string,
        private _recordType: string,
        private _maxFeatureCount: number,
        public printOptions: IPrintOptions,
        mappingTextPack: IMappingTextPack,
        user: HbsmrUser)
    {
        super(mappingTextPack, user);
        this.init();
    }

    private init = () => {
        if (this.initialised) {
            return;
        }

        this.layerConfigFactory = new DefaultLayerConfigurationFactory();
        this.vectorLayerGroupFactory = new VectorLayerGroupFactory();
        this.layerGroupFactory = new LayerGroupFactory(this.vectorLayerGroupFactory, null);
        this.mapFilter = new MapFilters();
        this.mapFilter.OgcFilter = new OgcMapFilter();
        this.baseLayerFactory = new KentBaseMapping_27700();
        this.featureLoader = new GeoJsonFeatureLoader();                
        this.featureAdd = new FeatureAddSmallGeomsAsPoint(4.5);

        this.mapFactory = new MapFactory();
        this.logger = new Logger();
        this.boundsLoaderBehaviour = new BoundsLoaderExtentsBehaviour(this.logger);
        this.styleFactory = new HbsmrStyleFactory();
        this.resourcefactory = new HbsmrResourcefactory(this.mappingTextPack);

        this.mfOptions = DefaultMapOptions.GetDefaultOptions(this._mapElementId, "RecordSearchMap27700");
        this.mfOptions.enableBoundsTracking = false;
        //zoom & centre determines the start position of the map
        this.mfOptions.mapZoom = 7;        
        //this.mfOptions.mapCentre = [591525, 147225];

        this.layerGroups = this.layerGroupFactory.getLayerGroups(this.getLayerGroupConfig(), this.styleFactory);
        this.mfOptions.layerGroupCollection = this.layerGroups;

        this.mapStore = new MapViewStore(this.mfOptions.mapStoreKey);
        //don't remember the layers if this is the first page of the search
        var qs = new URLSearchParams(window.location.search)        
        if (!qs.get("pn")) {        
            this.mapStore.clear()
        }

        this.herMask = new KentHerBoundary();
        this.mapContextMenu = new MapContextMenu(this.mappingTextPack);
        this.vectorLayerSourceFactory = new VectorLayerSourceFactory(this.logger, this.boundsLoaderBehaviour, this.featureLoader, this.featureAdd);
        this.map = this.mapFactory.instance(this.mfOptions, this.mapStore, this.logger, this.vectorLayerSourceFactory, this.baseLayerFactory, this.boundsLoaderBehaviour, this.mapContextMenu, this.printOptions, this.mapFilter, this.mappingTextPack);
        this.infoPopup = new MapFeatureInfo(this.map, this.resourcefactory.getRecordTypeResource(), this.mappingTextPack);
        let overlays = new CustomMapLayerSwitcherOverlays(this.map, this.mapStore, this.layerGroups, this.mappingTextPack);
        this.ls = new MapLayerSwitcher(this.map, this.mapStore, this.styleFactory, this.map.baseLayers, this.layerGroups, this.mappingTextPack, overlays, {
            showList: false,
            showOpenPanelByDefault: !this.printOptions.isPrintMap,
            rememberActivePanel: true
        });
        this.geoNames = new GeoNames(this.map, this.mappingTextPack);

        if (this.printOptions.isPrintMap) {
            this.printOptions.setMap(this.map);

            this.map.olMap.on('postrender', () => {
                //modify legends for layers with multiple styles
                const legendList = [
                    { layer: "Monuments", wfs_layer: "MonumentPointsWFS" },
                    { layer: "HLC", wfs_layer: "HLCPolygonsWFS" },
                    { layer: "DoverUAD_AngloSaxon", wfs_layer: "DoverUADAngloSaxonPolygonsWFS" },
                    { layer: "DoverUAD_EarlyRoman", wfs_layer: "DoverUADEarlyRoman" },
                    { layer: "DoverUAD_LateRoman", wfs_layer: "DoverUADLateRoman" },
                    { layer: "DoverUAD_Harbour1500", wfs_layer: "DoverUADHarbour1500PolygonsWFS" },
                    { layer: "DoverUAD_Medieval", wfs_layer: "DoverUADMedieval" },
                    { layer: "DoverUAD_PostMedieval1641", wfs_layer: "DoverUADPostMedieval1638to1641PolygonsWFS" },
                    { layer: "DoverUAD_PostMedieval1865", wfs_layer: "DoverUADPostMedieval1865PolygonsWFS" },
                    { layer: "DoverUAD_PostMedieval1908", wfs_layer: "DoverUADPostMedieval1908PolygonsWFS" }
                ]
                var legendDiv;
                legendList.forEach(legendConfig => {
                    legendDiv = document.getElementById(`map_legend_map_${legendConfig.layer}`);
                    if (legendDiv) {
                        const newImage = document.createElement('img');
                        newImage.src = `/api/OGCService/hbsmr?service=WMS&request=GetLegendGraphic&version=1.3.0&LAYER=${legendConfig.wfs_layer}&FORMAT=PNG&SLD_VERSION=1.1.0`;
                        newImage.alt = `${legendConfig.layer} Legend`;
                        legendDiv.innerHTML = ''; // clear the contents of the div
                        legendDiv.appendChild(newImage); // add the new image to the div
                    }
                });

            });
        }
        //this.downloadPng = new DownloadMapPng(this.map, this.mappingTextPack);
        this.gridRefFinder = new GridRef(this.map, this.mappingTextPack, this.logger);
        this.extentsNavigation = new ExtentsNavigation(this.map, this.logger, this.mappingTextPack);
        this.mousePosition = new MousePosition(this.map, this.mappingTextPack);

        if (!('ontouchstart' in window && navigator.maxTouchPoints > 0)) {
            //add tooltip if not touch
            this.mapToolTip = new MapToolTip(this.map, new ToolTipProvider(), new ToolTipOptions(7));
        }

        this.initialised = true;
    }


    private getLayerGroupConfig = (): Array<IlayerGroupCollectionConfig> => {
        let self = this;       

        let layerGroupConfig: Array<IVectorLayerGroupConfig> = [
            this.layerConfigFactory.layerConfig(KentRecordType.Monument),
            //this.layerConfigFactory.layerConfig(KentRecordType.Event),            
            this.layerConfigFactory.layerConfig(KentRecordType.Designation, KentRecordSubType.ListedBuilding),
            this.layerConfigFactory.layerConfig(KentRecordType.Designation, KentRecordSubType.ScheduledMonument),
            this.layerConfigFactory.layerConfig(KentRecordType.Designation, KentRecordSubType.RegisteredParksAndGardens),
            this.layerConfigFactory.layerConfig(KentRecordType.Designation, KentRecordSubType.HistoricParksAndGardens),
            this.layerConfigFactory.layerConfig(KentRecordType.Designation, KentRecordSubType.ConservationArea),
            this.layerConfigFactory.layerConfig(KentRecordType.HistoricLandscapeCharacterisation)
        ];

        layerGroupConfig.forEach(function (layer: IVectorLayerGroupConfig, index: number) {
            if (layer.type === self._recordType) {
                layer.displayName = layer.displayName + ' <i class="fas fa-filter"></i>',
                layer.layers.forEach(l => { l.layerName += "_Search" });

                if (layer.type === KentRecordType.Monument) {
                    layer.zoomToDataBounds = ZoomToDataBounds.Always;
                } else {
                    layer.zoomToDataBounds = ZoomToDataBounds.Never;
                }

                layer.strategy = VectorLayerStrategy.Bbox;
                layer.allowZoomToLoadedDataBounds = true;
                layer.visibleOnLoad = true;
                layer.maxFeatureCount = self._maxFeatureCount;
                layer.urlParams = {
                    ...{
                        searchstring: self._searchString,
                        searchmode: self._searchMode
                    }, ...layer.urlParams
                }
            }
        });

        return [
            {
                ref: "all_layers",
                name: "All layers",
                useAccordion: false,
                expandedOnFirstLoad: true,
                layerGroupConfigs: this.filterMapLayers(layerGroupConfig)
            }
        ];
    }

}